// 관리자 데이터 표 프리미티브.
// 표면/테두리/그림자/헤더 배경/행 구분선 등 반복되는 표 스타일을 한 곳에 모아
// 모든 목록 화면이 동일한 표 모양을 갖게 한다. head 에는 헤더 행(<tr><Th/>..)을, children 에는 본문 행을 넘긴다.

import type { ReactNode, ThHTMLAttributes, TdHTMLAttributes } from "react";

interface DataTableProps {
  head: ReactNode;
  children: ReactNode;
}

// 가로 스크롤 가능한 표면 카드 + 표. 헤더는 웜페이퍼 배경, 본문 행은 잉크 구분선.
export default function DataTable({ head, children }: DataTableProps) {
  return (
    <section className="overflow-x-auto rounded-lg border border-ink-200 bg-surface shadow-card">
      <table className="min-w-full text-sm">
        <thead className="bg-ink-50 text-left text-xs font-semibold text-ink-600">
          {head}
        </thead>
        <tbody className="divide-y divide-ink-200">{children}</tbody>
      </table>
    </section>
  );
}

// 표 헤더 셀.
export function Th({ children, className, ...rest }: ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <th className={`px-3 py-2.5 font-semibold ${className ?? ""}`} {...rest}>
      {children}
    </th>
  );
}

// 표 본문 셀.
export function Td({ children, className, ...rest }: TdHTMLAttributes<HTMLTableCellElement>) {
  return (
    <td className={`px-3 py-2 align-middle ${className ?? ""}`} {...rest}>
      {children}
    </td>
  );
}

// 로딩/빈 결과 등 표 전체 폭 메시지 행.
export function TableMessage({ colSpan, children }: { colSpan: number; children: ReactNode }) {
  return (
    <tr>
      <td colSpan={colSpan} className="px-3 py-8 text-center text-ink-600">
        {children}
      </td>
    </tr>
  );
}
